<template>
	<b-modal v-model="isActive" has-modal-card @close="closeModal()" :can-cancel="false">
		<div class="modal-card modalCardContainer" style="
							position: absolute;
							left: 50%;
							top: 50%;
							transform: translate(-50%, -50%);
					">
			<header class="modal-card-head" style="background-color: rgba(40, 40, 40, 1); color: white">
				Wichtiger Hinweis
			</header>
			<section class="modal-card-body" style="padding: 0.5em; color: black">
				<P>
					Ihr Session ist abgelaufen. Bitte melden Sie sich neu an.
				</P>
			</section>
			<footer class="modal-card-foot footerContainer" style="background-color: rgba(40, 40, 40, 1); color: white">
				<b-button @click="loginNow" type="is-primary">
					Jetzt neu anmelden
				</b-button>
			</footer>
		</div>

	</b-modal>
</template>

<script>

export default {
	name: "SessionInvalidModal",
	props: ["value"],
	data() {
		return {};
	},
	mounted() { },
	computed: {
		isActive: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			},
		},
	},
	methods: {
		closeModal() {
            this.isActive = false;
        },
		loginNow() {
			location.reload();
		}
	}
}

</script>

<style scoped></style>
